<template>
  <div class="dlrActivity-item">
    <div v-if="imageSrc" class="dlrActivity-pic">
      <img :src="imageSrc" />
    </div>
    <h2 class="dlrActivity-name">{{ title }}</h2>
    <h6 class="dlrActivity-publishCity" v-if="provinceName">
      发布于{{ provinceName }}
    </h6>
    <div class="dlrActivity-date">
      <p class="dlrActivity-date-title">报名时间</p>
      <p class="dlrActivity-date-info">
        <em class="grey-deep"
          >{{ toISODate(signStartTimeStr) }} -
          {{ toISODate(signEndTimeStr) }}</em
        >
        <span>（距报名截止时间还有{{ remainDays }}天）</span>
      </p>
    </div>
    <div class="dlrActivity-date">
      <p class="dlrActivity-date-title">活动时间</p>
      <p class="dlrActivity-date-info">
        <em class="grey-deep">
          {{ toISODate(startTimeStr) }} - {{ toISODate(endTimeStr) }}
        </em>
      </p>
    </div>
  </div>
</template>
<script>
import util from '../../utils/util';
export default {
  props: {
    imageSrc: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    signStartTimeStr: {
      type: String,
      default: ''
    },
    signEndTimeStr: {
      type: String,
      default: ''
    },
    remainDays: {
      type: Number,
      default: 0
    },
    startTimeStr: {
      type: String,
      default: ''
    },
    endTimeStr: {
      type: String,
      default: ''
    },
    provinceName: {
      type: String,
      default: ''
    },
  },
  methods: {
    toISODate (date) {
      return util.formatTime(date, 'yyyy-MM-dd');
    }
  }
};
</script>
<style lang="scss">
.dlrActivity-publishCity {
  font-size: ptrd(24px);
  color: #666d7f;
  text-align: right;
  line-height: ptrd(28px);
  margin-bottom: ptrd(16px);
}
</style>
